/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { AppContextModel } from '../model/AppContext.model';

// intentionally not passing callbacks below, they're provided in App Component as they use hooks
export const AppContext = createContext<AppContextModel>({} as AppContextModel);
